import { render, staticRenderFns } from "./image-file-svg.vue?vue&type=template&id=9c61db6c&scoped=true&"
var script = {}
import style0 from "./image-file-svg.vue?vue&type=style&index=0&id=9c61db6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c61db6c",
  null
  
)

export default component.exports